module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-15-81fa04fc4d958f4a236a24650af3ec6c.jpg";